// Steps/Step2Need.tsx
import { Stack } from '@mantine/core';
import { Select as CCMSSelect } from '@/components';
import type { WizardState } from '../types';

export default function Step1Need({ allNeeds, needID, setNeedID }: WizardState) {
  return (
    <Stack gap="md">
      <CCMSSelect
        label="Need"
        placeholder="Select a need"
        data={allNeeds.map((n) => ({ value: String(n.needID), label: n.name ?? `Need ${n.needID}` }))}
        value={needID ? String(needID) : null}
        onChange={(val) => setNeedID(val ? Number(val) : null)}
      />
    </Stack>
  );
}